import { Injectable, OnDestroy } from '@angular/core';
import io from 'socket.io-client';
import { Observable, Subject, defer, combineLatest } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';

import { ServerConn } from '../serverConn.service';
import { WindowRef } from '../_services/windowref.service';

import { WSMessage } from '../_interfaces/ws-message.interface';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService implements OnDestroy {

  public socket;
  private url: string;
  public observable: Observable<any>;
  private connectRetries = 0;
  private connecting = false;

  public unsubscribe = new Subject<void>();

  constructor(
    private server: ServerConn,
    private windowRef: WindowRef,
    private http: HttpClient,
  ) {
// this.url = this.server.serverUrl[this.server.mode + '_ws'];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  connect(): Observable<any> {

    if (typeof this.observable === 'undefined' && !this.connecting && !this.socket) {

      this.connecting = true;
      const paramsObj = new URLSearchParams();
      paramsObj.set('api_key', localStorage.getItem('api_key'));
      let res: any;
      this.http.get(this.server.serverUrl + 'ws-info' + '?' + paramsObj.toString())
        .subscribe((response: any) => {
          // console.log(res);
          res = response;
          this.url = this.windowRef.nativeWindow.location.protocol + '//' + res.data.host + ':'  + res.data.port;
          console.log(this.url);
          const api_key = localStorage.getItem('api_key');
          this.socket = io(this.url, { query: 'api_key=' + api_key });

          this.socket.on('connect', () => {
            console.log('WS connected!');
          });

          this.observable = new Observable(observer => {
            this.socket.on('messages', (data) => {
              // console.log('Received message from Websocket Server');
              observer.next(data);
            });
            return () => {
              this.socket.disconnect();
            };
          });

          this.connecting = false;

      });

    }

    // from our socket.io server.
    // We define our Observer which will listen to messages
    // from our other components and send messages back to our
    // socket server whenever the `next()` method is called.
    const observer = {
        next: (data: object | string) => {
          if (typeof data === 'string') {
            this.socket.emit('json', data);
          } else {
            this.socket.emit('json', JSON.stringify(data));
          }
        },
    };

    // // we return our Rx.Subject which is a combination
    // // of both an observer and observable.
    // // return Subject.create(observer, observable);
    // return Subject.create(observer, this.observable);
    return this.observable;
    // return this.socket.fromEvent('json').map(data => data.msg);
  }

  sendMessage(message: WSMessage) {
    this.socket.emit('json', message);
  }

}

